import React, { useState, useEffect } from "react";
import FETCH from "../../../utils/fetch";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import "../LiabilityDashboard.css";

export const LiabilityInfo = (props) => {
  const [loading, setLoading] = useState(false);
  console.log('props------------', props)

  function getLoanAmount(list, target) {
    if (!Array.isArray(list)) return "$0";
    const entry = list.find(
      (i) => i && i.module_name && i.module_name.toLowerCase() === target
    );
    return entry && entry.sum != null
      ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
      : "$0";
  }

  function getOtherLoansSum(list) {
    if (!Array.isArray(list)) return "$0";
    const excluded = ["auto", "real estates", "student"];
    const total = list.reduce((acc, curr) => {

      const name = curr && curr.module_name && curr.module_name.toLowerCase();
      return name && !excluded.includes(name)
        ? acc + (curr.sum || 0)
        : acc;
    }, 0);
    return "$" + total.toLocaleString(undefined, { minimumFractionDigits: 2 });
  }

  function calculateCreditUtilization(creditRows, totalCreditBalance, totalCreditLimit, creditCount) {
    let balance = parseFloat(totalCreditBalance) || 0;
    let limit = parseFloat(totalCreditLimit) || 0;

    // Fallback if aggregate limit is 0 but we have credit rows
    if (limit <= 0 && Array.isArray(creditRows) && creditRows.length > 0) {
      const totals = creditRows.reduce(
        (acc, row) => {
          acc.balance += parseFloat(row["Credit Balance"]) || 0;
          acc.limit += parseFloat(row["Credit Limit"]) || 0;
          return acc;
        },
        { balance: 0, limit: 0 }
      );

      if (totals.limit > 0) {
        balance = totals.balance;
        limit = totals.limit;
      }
    }

    if (limit <= 0) return "0.00%";

    const utilization = (balance / limit) * 100;

    if (isNaN(utilization) || !isFinite(utilization)) return "0.00%";

    return `${utilization.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`;
  }
  function calculateAverageInterestRate(creditRows, totalCreditBalance, totalCreditLimit, creditCount) {
    if (!Array.isArray(creditRows) || creditRows.length === 0) return "N/A";

    const total = creditRows.reduce((sum, row) => {
      const rate = parseFloat(row["Interest Rate (or APR%)"]);
      return sum + (!isNaN(rate) ? rate : 0);
    }, 0);

    const avg = total / creditRows.length;

    return avg.toFixed(2) + "%";
  }
  const RowData = [
    {
      id: 1,
      name: "Total Credit Lines",
      "Number Credit Card and Loans": (Number(props.total) || 0) + (Number(props.totalNoCredit) || 0),
      "Total Amount Credit Cards and Loans":
        `$${((parseFloat(props.totalLoan) || 0) + (parseFloat(props.totalBalance) || 0))
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      "Total Monthly Payments":
        `$${(parseFloat(props.totalMonthly) || 0)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },

    {
      id: 2,
      name: "Total Loan Balances",
      "Total Auto Loans":
        // props.totalAmountAll && props.totalAmountAll.auto
        //   ? `$${parseFloat(props.totalAmountAll.auto)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // (function () {
        //   const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
        //   if (!Array.isArray(list)) return "$0";

        //   const entry = list.find((i) => i && i.module_name && i.module_name.toLowerCase() === "auto");
        //   return entry && entry.sum != null
        //     ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
        //     : "$0";
        // })(),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";

          const totalAutoSum = list.reduce((acc, curr) => {
            return curr.module_name && curr.module_name.toLowerCase() === "auto"
              ? acc + Number(curr.sum || 0)
              : acc;
          }, 0);

          return "$" + totalAutoSum.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
      // getLoanAmount(props.newLiabilitySum, "auto"),
      "Total Home Loans":
        // props.totalAmountAll && props.totalAmountAll.realEstate
        //   ? `$${parseFloat(props.totalAmountAll.realEstate)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // (function () {
        //   const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
        //   if (!Array.isArray(list)) return "$0";

        //   const entry = list.find((i) => i && i.module_name && i.module_name.toLowerCase() === "real estates");
        //   return entry && entry.sum != null
        //     ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
        //     : "$0";
        // })(),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";

          const totalAutoSum = list.reduce((acc, curr) => {
            return curr.module_name && curr.module_name.toLowerCase() === "real estates"
              ? acc + Number(curr.sum || 0)
              : acc;
          }, 0);

          return "$" + totalAutoSum.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
      // getLoanAmount(props.newLiabilitySum, "real estates"),
      "Total Student Loans":
        // props.totalAmountAll && props.totalAmountAll.student
        //   ? `$${parseFloat(props.totalAmountAll.student)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // (function () {
        //   const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
        //   if (!Array.isArray(list)) return "$0";

        //   const entry = list.find((i) => i && i.module_name && i.module_name.toLowerCase() === "student");
        //   return entry && entry.sum != null
        //     ? "$" + Number(entry.sum).toLocaleString(undefined, { minimumFractionDigits: 2 })
        //     : "$0";
        // })(),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";

          const totalAutoSum = list.reduce((acc, curr) => {
            return curr.module_name && curr.module_name.toLowerCase() === "student"
              ? acc + Number(curr.sum || 0)
              : acc;
          }, 0);

          return "$" + totalAutoSum.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
      // getOtherLoansSum(props.newLiabilitySum),
      "Total Other Loans":
        // props.totalAmountAll && props.totalAmountAll.other
        //   ? `$${parseFloat(props.totalAmountAll.other)
        //       .toFixed(2)
        //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //   : " $0",
        // getOtherLoansSum(props.newLiabilitySum),
        (function () {
          const list = props.newLiabilitySum && props.newLiabilitySum.Liability;
          if (!Array.isArray(list)) return "$0";
          const excluded = ["auto", "real estates", "student"];
          const total = list.reduce((acc, curr) => {

            const name = curr && curr.module_name && curr.module_name.toLowerCase();
            return name && !excluded.includes(name)
              ? acc + (curr.sum || 0)
              : acc;
          }, 0);
          return "$" + total.toLocaleString(undefined, { minimumFractionDigits: 2 });
        })(),
    },
    {
      id: 3,
      name: "Total Credit Card Balances",
      "Total Number of Cards": Number(props.totalNoCredit) || 0,
      "Total Balances":
        `$${(parseFloat(props.totalBalance) || 0)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      "Total Credit Card Utilization":
        calculateCreditUtilization(props.creditRows, props.totalBalance, props.totalCreditLimit, props.creditCount),
      "Average Interest Rate":
        calculateAverageInterestRate(props.creditRows, props.totalBalance, props.totalCreditLimit, props.creditCount)
    },
    {
      id: 4,
      name: "Loan and Credit Card Details",
      "Highest Loan":
        // props.highestLoan &&
        // `$${parseFloat(props.highestLoan)
        //   .toFixed(2)
        //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
        props.liabilityCreditHigherValue && props.liabilityCreditHigherValue.highestLoanBalance &&
        `$${parseFloat(props.liabilityCreditHigherValue.highestLoanBalance)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      "Highest Interest Rate":
        // props.highestARP && `${props.highestARP + "%"}`,
        props.liabilityCreditHigherValue && props.liabilityCreditHigherValue.max_interest_rate && `${props.liabilityCreditHigherValue.max_interest_rate + "%"}`,
      "Highest Monthly Payment":
        // props.highestMonthly &&
        //   `${
        //     "$" +
        //     props.highestMonthly.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        //   }`,
        props.liabilityCreditHigherValue && props.liabilityCreditHigherValue.max_monthly_payment &&
        `${"$" +
        props.liabilityCreditHigherValue.max_monthly_payment
        }`,
      "Average Credit Age": props.totalMonthDiff
        ? formatMonths(props.totalMonthDiff)
        : "N/A",
    },
  ];
  const moduleStateMapping = {
    Student: "student",
    Auto: "auto",
    "Real Estates": "realEstate",
    // Add more mappings if needed
  };
  function formatMonths(totalMonths) {
    const total = parseFloat(totalMonths);
    if (isNaN(total) || total <= 0) return "N/A";

    // Calculate years and remaining months
    const years = Math.floor(total / 12);
    const months = (total % 12).toFixed(1);

    let result = "";
    if (years > 0) {
      result += `${years} year${years > 1 ? "s" : ""}`;
    }
    if (parseFloat(months) > 0) {
      result += ` ${months} month${parseFloat(months) > 1 ? "s" : ""}`;
    }
    return result.trim() || "N/A";
  }

  return (
    <React.Fragment>
      {RowData &&
        RowData.map((item, index) => (
          <div
            key={index}
            className="liablityInfocard"
            style={{ position: "relative" }}
          >
            <h3 className="liablitycardheading">{item.name}</h3>
            {Object.keys(item).map(
              (key, subIndex) =>
                key !== "name" &&
                key != "id" && (
                  <div key={subIndex}>
                    <div className="inforow" style={{ border: "none" }}>
                      <div
                        className="inforowData"
                        style={{
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                          gap: "4%",
                          justifyContent: "left",
                        }}
                      >
                        <span className="infoTitle1"> {key}:</span>
                        <span className="infosubTitle">
                          {/* {typeof item[key] === "number" ? `$ ${item[key]}` : item[key]} */}
                          {item[key]}
                        </span>
                      </div>
                    </div>
                  </div>
                )
            )}
            <NewLoader isLoading={props.loading} />
          </div>
        ))}
    </React.Fragment>
  );
};
